document.addEventListener('DOMContentLoaded', function () {
	let handButton = document.querySelector('[data-trigger="go-to-categories-nav"]');

	if (handButton) {
		// This also controls the categories nav, if it is hidden, it is revealed when the hand button is clicked
		let categoriesNav = document.querySelector('.categories-nav');
		if (categoriesNav) {
			categoriesNav.removeAttribute('style');
			categoriesNav.style.setProperty('--margin-top', `${categoriesNav.getBoundingClientRect().height}px`);

			window.addEventListener('resize', () => {
				categoriesNav.style.setProperty('--margin-top', `${categoriesNav.getBoundingClientRect().height}px`);
			})
		}

		// And this is for actually doing stuff when the hand button is clicked
		handButton.addEventListener('click', function () {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
			if (categoriesNav) {
				categoriesNav.classList.remove('hidden');
				categoriesNav.classList.add('highlight');

				setTimeout(() => {
					categoriesNav.classList.remove('highlight');
				}, 1000);
			}
		});
	}
})
